import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { styleHelper } from "../../shared/helpers/styleHelper";
import "./ShareDialog.scss";

interface ShareDialogProps {
  openDialog: boolean;
  link: string;
  onClose(): void;
}

const ShareDialog = ({ openDialog, onClose, link }: ShareDialogProps) => {
  const { t } = useTranslation("contactusform");
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
  };

  const onDialogClose = () => {
    setCopied(false);
    onClose();
  };

  return (
    <Dialog
      open={openDialog}
      onClose={onDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        {link && (
          <>
            <div className="sharedDialogHeader">{t("share.info")}</div>
            <div className="sharedDialogLink">{link}</div>
            {/* {copied ? (
              <div className="sharedDialogCopied">{t("share.linkcopied")}</div>
            ) : null} */}
            <DialogActions>
              <Button
                onClick={onDialogClose}
                variant="text"
                style={styleHelper.button}
              >
                {t("share.close")}
              </Button>
              <CopyToClipboard text={link} onCopy={handleCopy}>
                <Button variant="contained" style={styleHelper.button}>
                  {t("share.copylink")}
                </Button>
              </CopyToClipboard>
            </DialogActions>
          </>
        )}
        {!link && (
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
